import { useCallback, useState } from 'react';
import { Button, Pagination } from 'antd';
import { Plus } from 'lucide-react';
import { useSecrets } from './hooks/useSecrets';
import ObjectStorageCredentialTable from './components/ObjectStorageCredentialTable';
import CreateObjectStorageCredentialDialog from './components/CreateObjectStorageCredentialDialog';
import EditObjectStorageCredentialDialog from './components/EditObjectStorageCredentialDialog';
import CredentialNameSearch from './components/CredentialNameSearch';
import { type Secret } from '@/proto/agentplatform/v2/secret_pb';

export default function ObjectStorageCredentialsTab() {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [name, setName] = useState('');
  const { data, isLoading } = useSecrets(page, pageSize, true, name);
  const [createOpen, setCreateOpen] = useState(false);
  const [editTarget, setEditTarget] = useState<Secret | null>(null);

  const list = data?.data ?? [];
  const handleSearch = useCallback((value: string) => {
    setName(value);
    setPage(1);
  }, []);
  const totalCount = data?.total ?? 0;

  return (
    <>
      <div className="creds-toolbar">
        <span className="tab-desc">统一托管沙箱挂载使用的 S3 兼容对象存储 AK/SK</span>
        <div style={{ flex: 1 }} />
        <CredentialNameSearch onSearch={handleSearch} />
        <Button type="primary" icon={<Plus size={14} />} onClick={() => setCreateOpen(true)}>
          新建存储凭证
        </Button>
      </div>

      <ObjectStorageCredentialTable
        data={list}
        loading={isLoading}
        onEdit={(row) => setEditTarget(row)}
      />

      {!isLoading && totalCount > 0 && (
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
          <Pagination
            current={page}
            pageSize={pageSize}
            total={totalCount}
            showSizeChanger
            pageSizeOptions={[10, 20, 50, 100]}
            showTotal={(t) => `共 ${t} 条`}
            onChange={(p, ps) => {
              setPage(p);
              setPageSize(ps);
            }}
          />
        </div>
      )}

      <CreateObjectStorageCredentialDialog open={createOpen} onClose={() => setCreateOpen(false)} />
      <EditObjectStorageCredentialDialog
        open={!!editTarget}
        credential={editTarget}
        onClose={() => setEditTarget(null)}
      />
    </>
  );
}
